"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var compare_experiment_chart_1 = require("./compare-experiment.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
require('./compare-experiment.component.css');
function isGroupByAndColorBy(reportOptions) {
    if (!reportOptions) {
        return false;
    }
    return reportOptions.colorKey && reportOptions.groupKey;
}
var CompareExperimentComponent = /** @class */ (function (_super) {
    __extends(CompareExperimentComponent, _super);
    function CompareExperimentComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'CompareExperiment') || this;
        var ctrl = _this;
        ctrl.orientation = 'vertical';
        ctrl.chartType = 'bar';
        $scope.$on('command:COMPARE_EXPERIMENT', function (event, args) {
            ctrl.selectedX = 0;
            ctrl.selectedY = 0;
            ctrl.xAxisData = [];
            ctrl.yAxisData = [];
            ctrl.dataGot = args.config.data.data[0];
            ctrl.xAxisData = { data: ctrl.dataGot.headerMap[0]['data_x'], selected: ctrl.selectedX };
            // ctrl.yAxisData = { data: ctrl.dataGot.headerMap[0]['data_y'], selected: ctrl.selectedY };
            ctrl.initComponent(event, args);
            ctrl.menu = ctrl.getMenu();
            ctrl.menu.forEach(function (menuItem) {
                if (menuItem['name'] == 'Display') {
                    menuItem['items'].push({
                        'name': 'Rotate Chart',
                        'callback': function () {
                            ctrl.rotateChart();
                        }
                    });
                }
            });
        });
        return _this;
    }
    CompareExperimentComponent.prototype.getChartOptions = function (graph, options) {
        this.graph = graph;
        this.options = options;
        options['chartType'] = this.chartType;
        // let xKey = this.dataGot.headerMap[0]['data_x'][this.selectedX]['key'];
        // let xDisplay = this.dataGot.headerMap[0]['data_x'][this.selectedX]['display'];
        var xKey = this.dataGot.headerMap[0]['data_x'][this.selectedX]['key'];
        var xDisplay = this.dataGot.headerMap[0]['data_x'][this.selectedX]['display'];
        this.tableData = __assign({}, this.tableData, { inputData: __assign({}, this.tableData.inputData, { mainRows: compare_experiment_chart_1.filterZeroImpactIgnorance(this.tableData.inputData.mainRows).map(function (obj) {
                    obj.name = obj.pLabel;
                    return obj;
                }), headerMap: [{ "key": xKey, "text": xDisplay }] }) });
        if (graph.shouldTotal && this.tableData &&
            isGroupByAndColorBy(this.tableData.reportOptions)) {
            return compare_experiment_chart_1.getStackBarChartOptions(graph, options, xDisplay);
        }
        else {
            return compare_experiment_chart_1.getChartOptions(graph, options, this.xAxisData, this.yAxisData);
        }
    };
    CompareExperimentComponent.prototype.rotateChart = function () {
        this.orientation = this.orientation === 'horizontal' ? 'vertical' : 'horizontal';
        this.chartType = this.orientation === 'horizontal' ? 'column' : 'bar';
        var chartOptions = this.getChartOptions(this.graph, this.options);
        var chartGot = basic_chart_component_1.makeChart(chartOptions);
        basic_chart_component_1.handleResponsiveNess(chartGot);
    };
    CompareExperimentComponent.prototype.axisChanged = function () {
        var ctrl = this;
        ctrl.xAxisData = { data: ctrl.dataGot.headerMap[0]['data_x'], selected: ctrl.selectedX };
        var chartOptions = this.getChartOptions(this.graph, this.options);
        var chartGot = basic_chart_component_1.makeChart(chartOptions);
        basic_chart_component_1.handleResponsiveNess(chartGot);
    };
    CompareExperimentComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./compare-experiment.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], CompareExperimentComponent);
    return CompareExperimentComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.CompareExperimentComponent = CompareExperimentComponent;
angular.module('smartorg.r6.acts.compareExperiment', []).component('compareExperiment', CompareExperimentComponent);
exports["default"] = 'smartorg.r6.acts.compareExperiment';
//# sourceMappingURL=compare-experiment.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/compare-experiment/compare-experiment.component.js